export enum ServiceHistoryCodes {
    None = '0',
    Part = '1',
    Full = '2',
    FirstNotDue = '3'
}
